import BlockchainError from 'blockchain/BlockchainError.ts';

export default function getBlockchainErrorMessage(t: any, error: any, defaultMessage: string) {
  if (!(error instanceof BlockchainError)) return defaultMessage;

  return t(`blockchain.errors.${error.errorName}`, { defaultValue: defaultMessage });
}
